module.exports = __webpack_public_path__ + "bb031d77.svg";